import {
  FeatureName,
  StatusQuestionConfig,
  StatusResponseState,
  useIsFeatureEnabled,
} from '@gripp/shared-logic';
import { useEffect } from 'react';
import { useController } from 'react-hook-form';
import { useFormContext } from '../../../../forms';
import { StatusExecutionComponent } from '../../../status/statusExecutionComponent';
import {
  RoutineQuestionExecutionForm,
  RoutineQuestionExecutionFormProps,
} from '../types';
import { OpenEndedResponseExecutionComponent } from './openEndedResponseExecutionComponent';

// TODO: Crop Circle Redesign | Remove after feature is fully rolled out
const StatusQuestionExecutionFormOld: RoutineQuestionExecutionForm<
  StatusQuestionConfig,
  StatusResponseState
> = (
  props: RoutineQuestionExecutionFormProps<
    StatusQuestionConfig,
    StatusResponseState
  >
) => {
  const fieldPrefix = `responses.${props.responseIndex}`;
  const formKey = `${fieldPrefix}.status`;

  const { control, setValue } = useFormContext();
  const { field } = useController({
    control: control,
    name: formKey,
  });

  useEffect(() => {
    if (
      props.currentState?.state?.status ||
      props.currentState?.state?.responses?.[props.responseIndex]?.status
    ) {
      const currentStatus =
        props.currentState?.state?.responses?.[props.responseIndex]?.status ??
        props.currentState?.state?.status;
      setValue(formKey, currentStatus, {
        shouldDirty: false,
        shouldValidate: true,
      });
    }
  }, [props.currentState]);

  return (
    <>
      <StatusExecutionComponent
        statuses={props.config.statuses}
        onChange={field.onChange}
        value={field.value}
      />
      <OpenEndedResponseExecutionComponent {...props} />
    </>
  );
};

// TODO: Crop Circle Redesign | Remove to StatusQuestionExecutionFormBase after feature is fully rolled out
const StatusQuestionExecutionFormBase: RoutineQuestionExecutionForm<
  StatusQuestionConfig,
  StatusResponseState
> = (
  props: RoutineQuestionExecutionFormProps<
    StatusQuestionConfig,
    StatusResponseState
  >
) => {
  const fieldPrefix = `responses.${props.responseIndex}`;
  const formKey = `${fieldPrefix}.status`;

  const { control, setValue } = useFormContext();
  const { field } = useController({
    control: control,
    name: formKey,
  });

  useEffect(() => {
    if (
      props.currentState?.state?.status ||
      props.currentState?.state?.responses?.[props.responseIndex]?.status
    ) {
      const currentStatus =
        props.currentState?.state?.responses?.[props.responseIndex]?.status ??
        props.currentState?.state?.status;
      setValue(formKey, currentStatus, {
        shouldDirty: false,
        shouldValidate: true,
      });
    }
  }, [props.currentState]);

  return (
    <>
      <StatusExecutionComponent
        statuses={props.config.statuses}
        onChange={field.onChange}
        value={field.value}
        useCropCircle
      />
      <OpenEndedResponseExecutionComponent {...props} />
    </>
  );
};

// TODO: Crop Circle Redesign | Remove after feature is fully rolled out
export const StatusQuestionExecutionForm: RoutineQuestionExecutionForm<
  StatusQuestionConfig,
  StatusResponseState
> = (
  props: RoutineQuestionExecutionFormProps<
    StatusQuestionConfig,
    StatusResponseState
  >
) => {
  // TODO: Crop Circle Redesign | Remove after feature is fully rolled out
  const isCropCircleRedesignEnabled = useIsFeatureEnabled(
    FeatureName.CropCircleRedesign
  );

  // TODO: Crop Circle Redesign | Remove after feature is fully rolled out
  if (!isCropCircleRedesignEnabled) {
    return <StatusQuestionExecutionFormOld {...props} />;
  }

  // TODO: Crop Circle Redesign | Remove to StatusQuestionExecutionFormBase after feature is fully rolled out
  return <StatusQuestionExecutionFormBase {...props} />;
};
